import { LOGIN_TITLE } from '../../../constants/data';

export const LoginTitle = () => {
  return <div>{LOGIN_TITLE}</div>;
};
